/** @jsxImportSource @emotion/react */
import { twMerge } from 'tailwind-merge';
import {
  getCellVisibillityClasses,
  getCellVisibilityStatus,
  type ResponsiveSources,
} from './power-cell-getters';
import { ResponsiveText, type TextComponent } from './responsive-text';
import { type SerializedStyles } from '@emotion/react';

const textContainerClassName =
  'mb-label-b ml-label-l mr-label-r mt-label-t inline-flex whitespace-pre-wrap rounded-label bg-label pb-label-b pl-label-l pr-label-r pt-label-t font-label-font-family text-label-font-size tracking-label-letter-spacing text-label-color text-transform label-text-decoration label-width label-max-width';

export default function LabelV2({
  responsiveText,
  className,
  componentTextLabelTypography = 'p',
  isLoading,
  isLabelHover,
  isPreferenceSelectorCellAndSelected,
  dynamicColors,
}: {
  responsiveText: ResponsiveSources;
  className?: string;
  componentTextLabelTypography?: TextComponent;
  isLoading?: boolean;
  isLabelHover?: boolean;
  isPreferenceSelectorCellAndSelected?: boolean;
  dynamicColors?: SerializedStyles;
}) {
  const isVisible = getCellVisibilityStatus(responsiveText);

  if (!isVisible) {
    return <></>;
  }

  if (isLoading) {
    return (
      <Skeleton
        className={getCellVisibillityClasses(responsiveText, className)}
        componentTextLabelTypography={componentTextLabelTypography}
      />
    );
  }

  return (
    <div className={getCellVisibillityClasses(responsiveText, className)}>
      <div
        className={`${textContainerClassName} ${
          isLabelHover || typeof isLabelHover === 'undefined'
            ? 'group-hover:bg-label-hover group-hover:text-label-color-hover'
            : ''
        } ${
          isPreferenceSelectorCellAndSelected
            ? 'text-label-color-selected hover:text-label-color-selected-hover'
            : ''
        }`}
        css={dynamicColors}
      >
        <ResponsiveText
          responsiveText={responsiveText}
          componentTextLabelTypography={componentTextLabelTypography}
        />
      </div>
    </div>
  );
}

function Skeleton({
  className,
  componentTextLabelTypography,
}: {
  className?: string;
  componentTextLabelTypography?: TextComponent;
}) {
  return (
    <div className={className}>
      <div
        className={twMerge(
          textContainerClassName,
          'group-hover:bg-skeleton_background_color',
          'animate-pulse bg-skeleton_background_color'
        )}
      >
        <ResponsiveText
          responsiveText={{
            mobile: '                   ',
            tablet: '                   ',
            desktop: '                   ',
            'large-desktop': '                   ',
          }}
          componentTextLabelTypography={componentTextLabelTypography}
        />
      </div>
    </div>
  );
}
